/**
 * Canonical sidebar nav keys for NavPolicyConfig.
 * Paths must stay in sync with Sidebar.js navigation targets.
 */

export const SIDEBAR_NAV_ITEMS = [
  { key: 'dashboard', label: 'Overview', path: '/dashboard' },
  { key: 'patients', label: 'Patients', path: '/patients' },
  { key: 'upload_batches', label: 'Upload Batches', path: '/upload_batches' },
  { key: 'cohorts', label: 'Cohorts', path: '/cohorts' },
  { key: 'identifier_vault', label: 'Identifier Vault', path: '/identifier_vault' },
  { key: 'reporting', label: 'Reporting', path: '/reporting' },
];

/** Alternate paths that inherit another route's nav policy. */
export const NAV_POLICY_PATH_ALIASES = {
  '/user_dashboard': '/dashboard',
};

/** Paths that skip page-level nav policy checks (avoid redirect loops). */
export const NAV_POLICY_EXEMPT_PATHS = new Set(['/unauthorized', '/myprofile']);

export const getSidebarKeyForPath = (pathname) => {
  const resolved = NAV_POLICY_PATH_ALIASES[pathname] || pathname;

  const exact = SIDEBAR_NAV_ITEMS.find(({ path }) => path === resolved);
  if (exact) return exact.key;

  const byPrefix = [...SIDEBAR_NAV_ITEMS]
    .sort((a, b) => b.path.length - a.path.length)
    .find(({ path }) => resolved === path || resolved.startsWith(`${path}/`));

  return byPrefix?.key || null;
};
